<template>
  <div class="add-wrapper">
    <div class="add-section">
      <div class="base-info">
        <div class="type">就诊人信息</div>
        <div class="info">{{patientInfo.username}}<span>|</span>{{patientInfo.gender | genderFilter}}<span>|</span>{{patientInfo.birthday | ageFilter}}</div>
      </div>
      <div class="form-item click" @click="datePickerShow = true">
        <div class="form-type"><span class="required">就诊日期</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!date"><span>请选择</span>
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{date | dateFilter}}
            <icon icon-class="arrow" />
          </div>
        </div>
      </div>
      <div class="form-item click" @click="getDepartmentData">
        <div class="form-type"><span class="required">选择科室</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!departmentShowText"><span>请选择</span>
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{departmentMainText}} - {{departmentShowText}}
            <icon icon-class="arrow" />
          </div>
        </div>
      </div>
    </div>
    <div class="add-section part-two">
      <div class="form-item-vertical">
        <div class="form-type"><span class="required">上传 <em>初诊病历</em> 及 <em>处方单</em></span><span class="type-tips">最多上传9张</span></div>
        <div class="form-content">
          <div class="upload-list">
            <div class="upload-item" v-for="(item, index) in recordOssList">
              <span class="delPic" v-if="item.status == 5" @click="delRecordImage(item)">
                <icon icon-class="close"></icon>
              </span>
              <div class="preview-box">
                <img :src="item.url" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
                <div class="image-done" v-else>上传成功</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="wxRecordUploadCount>0">
              <div class="uploader-box" @click="wxRecordImgUpload()">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-item-vertical">
        <div class="form-type"><span>上传现有辅助检查结果、报告</span><span class="type-tips">最多上传9张</span></div>
        <div class="form-content">
          <div class="upload-list">
            <div class="upload-item" v-for="(item, index) in reportOssList">
              <span class="delPic" v-if="item.status == 5" @click="delReportImage(item)">
                <icon icon-class="close"></icon>
              </span>
              <div class="preview-box">
                <img :src="item.url" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
                <div class="image-done" v-else>上传成功</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="wxReportUploadCount>0">
              <div class="uploader-box" @click="wxReportImgUpload()">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="save-box"><button class="save-button" @click="saveRecordValid">保存</button></div>
    <!-- 就诊日期选择 -->
    <van-popup v-model="datePickerShow" position="bottom">
      <van-datetime-picker show-toolbar type="date" v-model="pickerDate" :min-date="minDate" :max-date="maxDate"
        @cancel="datePickerShow = false" @confirm="confirmDate" />
    </van-popup>
    <!-- 科室选择 -->
    <van-popup v-model="departmentPickerShow" position="bottom" title="选择科室" class="department-selector">
      <van-tree-select :items="departmentData" :main-active-index="departmentMainActiveIndex" :active-id="departmentActiveId"
        @navclick="navClick" @itemclick="itemClick" />
    </van-popup>
    <x-dialog v-if="comfirmSaveShow" title="添加病历" :dialog-width="'80%'" @close="comfirmSaveShow = false">
      <div class="save-content">
        <div class="text">请确认病历信息，保存后不可进行编辑和删除</div>
        <div class="save-control">
          <button class="cancel" @click="comfirmSaveShow = false">再修改一下</button>
          <button class="confirm" @click="confirmSave" :disabled="saving">确认保存</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .add-wrapper{
    padding-top: 1px;
    background: #F7F7F7;
    min-height: 100vh;
    .add-section{
      margin-top: 12px;
      background: #FFF;
      padding: 31px 0 20px;
      &.part-two{
        padding-bottom: 1px;
      }
      .base-info{
        padding: 0 16px;
        margin-bottom: 20px;
        .type{
          font-size: 16px;
          line-height: 16px;
          font-weight: bold;
          color: #666;
        }
        .info{
          margin-top: 12px;
          font-size: 16px;
          line-height: 16px;
          color: #333;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          span{
            margin: 0 10px;
            color: #CCC;
          }
        }
      }
      .form-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        padding: 0 16px;
        margin-bottom: 16px;
        font-size: 16px;
        transition: all .2s;
        &.click:active{
          background: #F9F9F9;
        }
        &:last-child{
          margin-bottom: 0;
        }
        .form-type{
          font-size: 16px;
          color: #666;
          font-weight: bold;
          .required{
            position: relative;
            &::after{
              content: '*';
              position: absolute;
              left: 100%;
              top: 0;
              margin-left: 2px;
              font-size: 16px;
              color: @error;
            }
          }
        }
        .form-content{
          .picker-tips{
            font-size: 16px;
            line-height: 40px;
            color: #999;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            svg{
              color: #CCC;
              position: relative;
              font-size: 14px;
              height: 14px;
              margin-left: 4px;
            }
          }
          .picker-value{
            max-width: 240px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            line-height: 40px;
            color: #333;
            svg{
              color: #CCC;
              position: relative;
              font-size: 14px;
              height: 14px;
              margin-left: 4px;
            }
          }
        }
      }
      .form-item-vertical{
        padding: 0 16px;
        margin-bottom: 40px;
        .form-type{
          font-size: 16px;
          color: #666;
          font-weight: bold;
          .required{
            position: relative;
            em{
              color: @xile;
            }
            &::after{
              content: '*';
              position: absolute;
              left: 100%;
              top: 0;
              margin-left: 2px;
              font-size: 16px;
              color: @error;
            }
          }
          .tips{
            margin-top: 6px;
            font-size: 12px;
            color: @xile;
          }
          .type-tips{
            margin-left: 15px;
            font-size: 14px;
            color: #999;
          }
        }
        .form-content{
          position: relative;
          margin-top: 12px;
          .upload-list{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            margin-bottom: -16px;
            .upload-item{
              position: relative;
              width: 96px;
              height: 96px;
              margin: 0 16px 16px 0;
              &:nth-child(3n){
                margin-right: 0
              }
              .preview-box{
                position: relative;
                width: 100%;
                height: 100%;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                border-radius: 4px;
                background: #000;
                img{
                  width: 100%;
                }
                .image-status{
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 20px;
                  line-height: 20px;
                  background: rgba(0, 0, 0, .5);
                  color: #FFF;
                  text-align: center;
                  font-size: 12px;
                }
                .image-done{
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 20px;
                  line-height: 20px;
                   background: @xile;;
                  color: #FFF;
                  text-align: center;
                  font-size: 12px;
                }
              }
              .delPic{
                position: absolute;
                top: -8px;
                right: -8px;
                width: 20px;
                height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #DDD;
                border-radius: 50%;
                background: #FFF;
                z-index: 20;
                svg{
                  font-size: 12px;
                  color: #999;
                }
              }
              &.uploader{
                .uploader-box{
                  width: 100%;
                  height: 100%;
                  border: 1px dashed #CCC;
                  background: #F3F3F3;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 4px;
                  svg{
                    font-size: 28px;
                    color: #CCC;
                  }
                }
              }
            }
          }
        }
      }
    }
    .save-box{
      padding: 24px 8px;
      .save-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }
    .save-content{
      padding: 24px 28px 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        font-size: 15px;
        line-height: 21px;
        color: @black;
        font-weight: bold;
        span{
          margin: 0 6px;
          color: @xile;
        }
      }
      .save-control{
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          width: 117px;
          height: 36px;
          &.cancel{
            @button-border();
            margin-right: 13px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        patientInfo: {},
        // 日期
        date: null,
        pickerDate: new Date(),
        minDate: new Date(1970, 0, 1),
        maxDate: new Date(),
        datePickerShow: false,
        // 科室
        mainDepartment: '',
        department: '',
        departmentData: [],
        departmentPickerShow: false,
        departmentMainActiveIndex: 0,
        departmentMainText: '',
        departmentActiveId: null,
        departmentShowText: '',
        // 上传病历照片实例
        recordUploader: null,
        recordImgList: [],
        recordOssList: [],
        wxRecordUploadLocalArray: [],
        wxRecordUploadServerArray: [],
        wxRecordUploadCount: 9,
        wxRecordUploadStatus: false,
        // 上传现有辅助检查结果、报告实例
        reportUploader: null,
        reportImgList: [],
        reportOssList: [],
        wxReportUploadLocalArray: [],
        wxReportUploadServerArray: [],
        wxReportUploadCount: 9,
        wxReportUploadStatus: false,

        comfirmSaveShow: false,
        saving: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      xDialog
    },
    created() {
      let _this = this;
      //加载jssdk
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseImage', 'uploadImage']
          });

        }

      })
      this.$root.post('/getPatientDetail', {
        pat_id: this.userInfo.user_id
      }).then(data => {
        this.patientInfo = data;
      })
      this.$root.post('/getDepartmentList').then(data => {
        this.departmentData = data;
      })
    },
    mounted() {
      //this.setMultipleUpload(this.recordUploader, 'recordUploader', 'recordImgList', 'recordOssList');
      //this.setMultipleUpload(this.reportUploader, 'reportUploader', 'reportImgList', 'reportOssList');
    },
    methods: {
      wxReportSyncUpload() {
        let _this = this;
        if (_this.wxReportUploadLocalArray.length == 0) {
          _this.wxReportUploadStatus = false;
        } else {
          var entry = _this.wxReportUploadLocalArray.shift();
          _this.wxReportUploadCount -= 1;
          wx.uploadImage({
            localId: entry.localid,
            isShowProgressTips: 0,
            success: function(res) {
              var serverId = res.serverId
              _this.wxReportUploadServerArray.push(serverId);

              _this.reportOssList.forEach(item => {
                if (item.localid == entry.localid) {
                  item.serverid = serverId
                }
              });
              console.log("上传第" + entry.localid + '张')

              _this.$root.post('/getWxImg', {
                id: serverId,
                oss_dir: 'patient',
                filename: serverId,
                type: 1
              }).then(data => {
                console.log("返回服务端数据")
                console.log(data)
                if (data.status == 1) {
                  _this.reportOssList.forEach(item => {
                    if (item.serverid == serverId) {
                      item.url = data.url;
                      item.status = 5;
                    }
                  });

                } else {
                  _this.$notify('发送图片失败');
                }
              })


              _this.wxReportSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxReportImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: _this.wxReportUploadCount, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            _this.wxReportUploadStatus = true;
            res.localIds.forEach(item => {
              var entry = {
                status: 1,
                localid: item,
                url: item,
                serverid: ''
              };
              _this.wxReportUploadLocalArray.push(entry);
              _this.reportOssList.push(entry);
            });

            _this.wxReportSyncUpload();

          }
        });

      },
      delReportImage(item) {
        let _this = this;
        let index = _this.reportOssList.indexOf(item)
        _this.reportOssList.splice(index, 1);
        _this.wxReportUploadCount += 1;
      },
      wxRecordSyncUpload() {
        let _this = this;
        if (_this.wxRecordUploadLocalArray.length == 0) {
          _this.wxRecordUploadStatus = false;
        } else {
          var entry = _this.wxRecordUploadLocalArray.shift();
          _this.wxRecordUploadCount -= 1;
          wx.uploadImage({
            localId: entry.localid,
            isShowProgressTips: 0,
            success: function(res) {
              var serverId = res.serverId
              _this.wxRecordUploadServerArray.push(serverId);

              _this.recordOssList.forEach(item => {
                if (item.localid == entry.localid) {
                  item.serverid = serverId
                }
              });
              console.log("上传第" + entry.localid + '张')

              _this.$root.post('/getWxImg', {
                id: serverId,
                oss_dir: 'patient',
                filename: serverId,
                type: 1
              }).then(data => {
                console.log("返回服务端数据")
                console.log(data)
                if (data.status == 1) {
                  _this.recordOssList.forEach(item => {
                    if (item.serverid == serverId) {
                      item.url = data.url;
                      item.status = 5;
                    }
                  });

                } else {
                  _this.$notify('发送图片失败');
                }
              })


              _this.wxRecordSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxRecordImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: _this.wxRecordUploadCount, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            _this.wxRecordUploadStatus = true;
            res.localIds.forEach(item => {
              var entry = {
                status: 1,
                localid: item,
                url: item,
                serverid: ''
              };
              _this.wxRecordUploadLocalArray.push(entry);
              _this.recordOssList.push(entry);
            });

            _this.wxRecordSyncUpload();

          }
        });

      },
      delRecordImage(item) {
        let _this = this;
        let index = _this.recordOssList.indexOf(item)
        _this.recordOssList.splice(index, 1);
        _this.wxRecordUploadCount += 1;
      },
      // 点击选择科室
      getDepartmentData() {
        if (this.departmentData.length == 0) {
          // get data
        }
        this.departmentPickerShow = true;
      },
      // 点击科室一级
      navClick(index) {
        this.departmentMainActiveIndex = index;
        // this.departmentMainText = this.departmentData[index].text;
      },
      itemClick(data) {
        this.departmentActiveId = this.department = data.id;
        this.departmentShowText = data.text;
        this.departmentPickerShow = false;
        this.departmentData.forEach((items, index) => {
          if (items.children) {
            items.children.forEach(item => {
              if (item.id == data.id) {
                this.mainDepartment = items.id;
                this.departmentMainText = items.text;
              }
            })
          }
        })
      },
      // 上传多张张函数
      setMultipleUpload(obj, id, file, finalList) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {},
          // 多文件上传
          multi_selection: true,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              // 获取当前已上传的图片数量
              let objLength = _this[file].length;
              files.forEach(item => {
                // 如果本次选中的图片数量超出了9张的限制，则自动删除多出的图片
                objLength++;
                if (objLength > 9) {
                  up.removeFile(item);
                };
                /* 注释预览
                let fileName = item.name;
                _this.$root.previewUploadImage(item, (imgSrc) => {
                  item.previewImage = imgSrc;
                  _this[file].push(item);
                })
                */
              })
              _this.$root.setUploadParam(up, '', false);
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              _this.$root.setUploadParam(up, fileObj.name, true);
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              if (info.status == 200) {
                let res = JSON.parse(info.response);
                _this[finalList].push(res.path)
                //上传成功后再形成预览图
                console.log(_this[file])
                fileObj.previewImage = res.thumb;
                _this[file].push(fileObj);
                // _this.avatar = res.path;
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      // 删除已上传的图片
      delPic(item, obj, ossObj) {
        let index = this[obj].indexOf(item)
        this[obj].splice(index, 1);
        this[ossObj].splice(index, 1);
      },
      confirmDate() {
        this.date = parseInt(this.pickerDate / 1000);
        this.datePickerShow = false;
      },
      saveRecordValid() {
        if (!this.date) {
          this.$notify('请选择就诊日期');
          return;
        }
        if (!this.department || !this.mainDepartment) {
          this.$notify('请选择就诊科室');
          return;
        }
        if (this.recordOssList.length == 0) {
          this.$notify('请上传您的初诊病历及处方单');
          return;
        }
        if (this.wxRecordUploadStatus) {
          this.$notify('请等待所有图片上传完成');
          return;
        }
        if (this.wxReportUploadStatus) {
          this.$notify('请等待所有图片上传完成');
          return;
        }
        this.comfirmSaveShow = true;
      },
      confirmSave() {
        let _this = this;
        console.log('1111')
        this.saving = true;
        var case_img = [];
        if (this.recordOssList.length > 0) {
          this.recordOssList.forEach(item => {
            if (item.status == 5) {
              case_img.push(item.url);
            }
          });
        }
        var result_img = [];
        if (this.reportOssList.length > 0) {
          this.reportOssList.forEach(item => {
            if (item.status == 5) {
              result_img.push(item.url);
            }

          });
        }
        this.$root.post('/addPatientCase', {
          pat_id: this.userInfo.user_id,
          dep_id: this.department,
          dep_pid: this.mainDepartment,
          case_time: this.date,
          case_img: case_img,
          result_img: result_img,
        }).then(data => {
          this.saving = false;
          if (data.status == 1) {
            this.$notify({
              message: '添加成功',
              background: '#00848A'
            });
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500)
          } else {
            this.$notify(data.msg);
          }
        })
      }
    },
    filters: {
      dateFilter(value) {
        return moment.unix(value).format('YYYY.MM.DD');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/MedicalRecord/addRecord.vue